// Centralized locale configuration
// To add a new language: simply add a new object to the array

export const localesConfig = [
  {
    code: 'en-us',
    lokaliseCode: 'en_US',  // Lokalise uses underscores and region codes
    name: 'US (English)',
    shortName: 'EN',
    flag: 'US',
    isDefault: true
  },
  {
    code: 'es-us',
    lokaliseCode: 'es_US',
    name: 'US (Español)',
    shortName: 'ES (US)',
    flag: 'ES',
    isDefault: false
  },
  {
    code: 'en-uk',
    lokaliseCode: 'en_UK',
    name: 'UK (English)',
    shortName: 'EN',
    flag: 'GB',
    isDefault: false
  }
];

// Locale helpers
export const localeCodes = localesConfig.map(l => l.code);
export const defaultLocale = localesConfig.find(l => l.isDefault)?.code || 'en-us';

export const getLocaleConfig = (code) =>
  localesConfig.find(l => l.code === code);

export const getLocaleName = (code) =>
  getLocaleConfig(code)?.name || code;

export const getLocaleShortName = (code) =>
  getLocaleConfig(code)?.shortName || code;

export const getLocaleFlag = (code) =>
  getLocaleConfig(code)?.flag || code;

// Lokalise helpers (for scripts)
export const getLokaliseCode = (code) =>
  getLocaleConfig(code)?.lokaliseCode || code.replace('-', '_');

export const getLocaleFromLokalise = (lokaliseCode) => {
  const config = localesConfig.find(l => l.lokaliseCode === lokaliseCode);
  return config?.code || lokaliseCode.replace('_', '-');
};

// Object map of locale code to locale name (for LanguageSwitcher)
export const localeNames = Object.fromEntries(
  localesConfig.map(l => [l.code, l.name])
);